module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-slovenia-gourmet.svg?75a84ac4cae97efdf34d33ce21ce912a";